import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/t1.png")